import { SVGAttributes } from './types';

const defaultAttributes: Record<'outline' | 'filled', SVGAttributes> = {
  outline: {
    xmlns: 'http://www.w3.org/2000/svg',
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    fill: 'none',
    stroke: 'currentColor',
    'stroke-width': 2,
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
  },
  filled: {
    xmlns: 'http://www.w3.org/2000/svg',
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    fill: 'currentColor',
    stroke: 'none',
  },
};

export default defaultAttributes;
